import { defineBoot } from '#q-app/wrappers';
import { unfocusOnValue } from 'src/directives/vUnfocusOnValue';
/**
 * Register global directives
 */
export default defineBoot(({ app }) => {
    app.directive('unfocusOnValue', unfocusOnValue);
});
